import { getLicenseDaysRemaining } from './licenseDuration';

export const LicenseStatus = {
    Revoked: 'Revoked',
    Expired: 'Expired',
    Activated: 'Activated',
    NotActivated: 'Not Activated',
};

export function getLicenseStatusLabel(row, now = new Date()) {
    if (row?.revoked) {
        return LicenseStatus.Revoked;
    }

    if (row?.used === true) {
        if (row?.licenseExpiration == null) {
            return LicenseStatus.Activated;
        }
        const daysRemaining = getLicenseDaysRemaining(row, now);
        if (daysRemaining != null && daysRemaining <= 0) {
            return LicenseStatus.Expired;
        }
        return LicenseStatus.Activated;
    }

    if (row?.used === false) {
        return LicenseStatus.NotActivated;
    }

    return '';
}

export function licenseStatusValueGetter(_value, row) {
    return getLicenseStatusLabel(row);
}
